



// Get all anchor elements on the page
var anchorElements = document.querySelectorAll('a');

// Define the old and new domain
var oldDomain = 'https://barska.wpengine.com';
var newDomain = 'https://barska.com';

// Loop through each anchor element
for (var i = 0; i < anchorElements.length; i++) {
    var href = anchorElements[i].getAttribute('href');
    
    // Check if the href contains the old domain
    if (href && href.indexOf(oldDomain) !== -1) {
        // Replace the old domain with the new domain
        var newHref = href.replace(oldDomain, newDomain);
        anchorElements[i].setAttribute('href', newHref);
    }
}





// ADD SKU TO PRODUCT CARDS
  document.addEventListener('DOMContentLoaded', function () {
    var productCards = document.querySelectorAll('.product-card');

    productCards.forEach(function (card) {
      var skuElement = card.querySelector('.product-sku');
      var sku = skuElement.innerText;

      // Additional JavaScript operations, if needed
      console.log('SKU:', sku);
    });
  });



